//@ts-nocheck
import React from "react";
import { withRouter } from "react-router";
import withAlertBox from "../../../../components/src/withAlertBox.Web";
import withToast from "../../../../components/src/withSnackBar.Web";
import withLoader from "../../../../components/src/withLoader.Web";
import withDialog from "../../../../components/src/withDialog.web";
import withConfirmBox from "../../../../components/src/withConfirmBox.Web";
import QuestionCard from "./layout/QuestionCard.web";
import OptionList from "./layout/OptionList.web";
import StepFooter from "./layout/StepFooter.web";
import FirmQuestions from "./layout/FirmQuestions.web";
import GeneratingPackage from "./layout/GeneratingPackage.web";

class ReportingStep extends React.Component {
  async componentDidMount() {
    const stepNo = this.props.taxPayerType === "individual" ? "9.1" : "9.2";
    this.props.getQuestionAndOptionsByStepNo(stepNo);
  }
  render() {
    const selection = this.props.reportSelection || [];
    if (this.props.isLoaderStep) {
      return <GeneratingPackage />;
    }
    return (
      <>
        <QuestionCard
          title={this.props?.stepContent?.description}
          hint="Select any that apply"
        >
          <OptionList
            options={this.props?.stepContent?.options?.data}
            selected={selection}
            multiple
            onSelect={this.props.setReportingSelection}
          />
        </QuestionCard>
        <FirmQuestions
          screen="reporting"
          taxPayerType={this.props.taxPayerType}
          questions={this.props.firmQuestions}
          answers={this.props.firmAnswers}
          onChange={this.props.setFirmAnswer}
        />
        <StepFooter
          onBack={this.props.handleBack}
          onNext={this.props.saveSurvey}
          nextDisabled={selection.length === 0}
          nextLabel="Generate your package"
        />
      </>
    );
  }
}
const ReportingStepWithRouter = withRouter(ReportingStep);
const ReportingStepAlertBox = withAlertBox(ReportingStepWithRouter);
const ReportingStepLoader = withLoader(ReportingStepAlertBox);
const ReportingStepToast = withToast(ReportingStepLoader);
const ReportingStepWithDialog = withDialog(ReportingStepToast);

export default withConfirmBox(ReportingStepWithDialog);
